<template>
  <v-dialog
    v-model="show"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title>
        Jira Access
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-4">
        Please fill all the fields to get the access to the Jira REST API.
        To get API Token go to the
        <a href="https://id.atlassian.com/manage-profile/security/api-tokens" target="_blank" class="px-1">API Tokens manager</a>
        and create new one. After that paste your token to the "Jira API Token" field.

        <div class="d-flex align-center mt-4">
          <v-chip
            v-if="tokenStatus !== null"
            small
            :color="tokenStatusColor"
            text-color="white"
            class="mr-2"
          >
            <v-icon small left>{{ tokenStatusIcon }}</v-icon>
            {{ tokenStatusText }}
          </v-chip>
          <v-btn
            small
            text
            :loading="checkingToken"
            :disabled="checkingToken"
            @click="checkTokenValidity"
          >
            <v-icon small left>mdi-refresh</v-icon>
            Check token
          </v-btn>
        </div>

        <v-text-field
          class="mt-5 pt-3"
          dense
          hide-details
          label="Jira login"
          v-model="jiraApiDefaultLogin"
        ></v-text-field>
        <v-text-field
          class="mt-5 pt-3"
          dense
          hide-details
          label="Jira API Token"
          type="password"
          v-model="jiraApiToken"
          @input="tokenStatus = null"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" @click="show = false">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :disabled="!jiraApiDefaultLogin || !jiraApiToken"
          @click="saveJiraRestApiAccessInformation">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'JiraApiTokenDialog',
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      jiraApiDefaultLogin: null,
      jiraApiToken: null,
      tokenStatus: null,
      checkingToken: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    tokenStatusColor () {
      const colors = {
        valid: 'success',
        unauthorized: 'error',
        no_token: 'grey',
        no_integration: 'warning',
        error: 'error'
      }
      return colors[this.tokenStatus] || 'grey'
    },
    tokenStatusIcon () {
      const icons = {
        valid: 'mdi-check-circle',
        unauthorized: 'mdi-alert-circle',
        no_token: 'mdi-minus-circle',
        no_integration: 'mdi-help-circle',
        error: 'mdi-alert-circle'
      }
      return icons[this.tokenStatus] || 'mdi-minus-circle'
    },
    tokenStatusText () {
      const texts = {
        valid: 'Token is valid',
        unauthorized: 'Token is expired or invalid',
        no_token: 'No token saved',
        no_integration: 'Token saved, but no Jira integration configured to verify',
        error: 'Could not verify token'
      }
      return texts[this.tokenStatus] || ''
    }
  },
  mounted () {
    this.jiraApiDefaultLogin = this.user.e_mail
    this.checkTokenValidity()
  },
  methods: {
    checkTokenValidity () {
      this.checkingToken = true
      this.axios.post('/api/integrations/verify-jira-token', {
        Employee_ID: this.user.employee_id
      }, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(res => {
        this.tokenStatus = res.data.valid ? 'valid' : (res.data.reason || 'error')
      }).catch(() => {
        this.tokenStatus = 'error'
      }).finally(() => {
        this.checkingToken = false
      })
    },
    saveJiraRestApiAccessInformation () {
      this.jiraApiTokenDialog = false
      this.axios.post('/api/integrations/jira-access', {
        Employee_ID: this.user.employee_id,
        Jira_Login: this.jiraApiDefaultLogin,
        API_Token: this.jiraApiToken
      },
      {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$emit('successSaved')
        this.show = false
        this.$store.dispatch('setSuccess', { successMsg: 'Your access information successfuly saved' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  }
}
</script>
